export enum ExtractionFrequencyEnum {
    'ONE_TIME' = 'ONE_TIME',
    'DAILY' = 'DAILY',
    'WEEKLY' = 'WEEKLY',
    'MONTHLY' = 'MONTHLY'
}